import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#8d5fff",
      d: "m10.707 8.707 4.253 4.252c.63.63.183 1.707-.708 1.707H5.749c-.891 0-1.337-1.077-.707-1.707l4.252-4.252a1 1 0 0 1 1.414 0"
    }, null, -1)
  ]))]))
}
export default { render: render }